import React from 'react';
import PropTypes from 'prop-types';

const Total = ({
  total,
  bemBlock,
}) => {
  const totalInDollars = (total / 100).toLocaleString();

  return (
    <div className={`${bemBlock}__total`}>
      <span> Total:</span>
      <span style={{ fontSize: '1.625rem' }}>{`$${totalInDollars}`}</span>
    </div>
  );
};

Total.propTypes = {
  total: PropTypes.number.isRequired,
  bemBlock: PropTypes.string.isRequired,
};

export default Total;
